/**
 * @module support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const INPUT_AUTOCOMPLETE_CONSTANTS = {
  BYPASS: 'BYPASS',
};

export const MESSAGE_TYPE_CONSTANTS = {
  SUCCESS: 'success',
};

export const TOOLTIP_CONSTANTS = {
  APPENDTO: 'body',
  TEXT: 'Tooltip default Text',
  EVENT: 'focus',
  POSITION: 'bottom',
  STYLE: 'style',
};

export const WIDGETS_CONSTANTS = {
  WIDGETS_MODULE: 'WidgetsModule',
};

export const BACK_TO_TOP_CONSTANTS = {
  STYLE: 'style',
  INNERHEIGHT: 'innerHeight',
  SCROLLTOP: 'scrollTop',
};

export const POPTOKEN_UTIL = {
  MILLISECONDS: 1000,
  SECONDS: 60,
  MINUTES: 2,
};

export const BANNER_CLASS = {
  BANNER_PREPAID: 'banner-prepaid',
  BANNER_CONNECT: 'banner-connect',
};
